import request from '../../request/metorequest'
import axios from 'axios'

// @获取meteoToken
//   {
//     "appId": "JF2021011901",
//     "secret": "secret"
//   }
export function getToken (data) {
  return request({
    method: 'post',
    url: '/us/users/open/auth',
    data
  })
}

// @获取某时间点的台风信息
//   {
//     "type": "normal",
//     "timestamp": 1637744008000 //不填时获取最新的台风信息
//   }
export function getTyphoon (params) {
  return request({
    method: 'get',
    url: '/typhoon/v2/forecast/newest',
    params
  })
}

// @获取栅格图片
export function loadImg(url) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: url,
      dataType: "image",
      crossDomain: true,
      cache: false
    }).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}


